import { ComponentFactoryResolver, ComponentRef, Injectable, Injector } from '@angular/core';
import { PoprModalComponent } from './popr-modal.component';
import { Popr } from '../popr';
import { PoprViewService } from '../popr-view.service';
import { Observable } from 'rxjs';

/**
 * Container for a component which is the content of a modal.
 *
 * @see {@link PoprService}
 */
@Injectable({
  providedIn: 'any'
})
export class PoprModal<T>  extends Popr {
  private readonly dynamicComponent$: Observable<T>;
  private readonly poprModalComponentRef!: ComponentRef<PoprModalComponent<T>>;
  private poprModalComponent!: PoprModalComponent<T>;

  constructor(
    private injector: Injector,
    private poprView: PoprViewService<PoprModalComponent<T>>,
    private resolver: ComponentFactoryResolver,
  ) {
    super();
    this.poprModalComponentRef = this.createPoprModalComponentRef();
    this.poprModalComponent = this.poprModalComponentRef.instance;
    this.dynamicComponent$ = this.poprModalComponent.component$();
    this.poprModalComponent?.onClose$()?.subscribe(() => {
      this.poprModalComponentRef?.destroy();
      super.close();
    });
  }

  /**
   * Get the dynamic component when it becomes available
   */
  component$(): Observable<T> {
    return this.dynamicComponent$;
  }

  /**
   * @inheritDoc
   */
  open(): void {
    this.poprView.insert(this.poprModalComponentRef);
    super.open();
  }

  /**
   * @inheritDoc
   */
  close(): void {
    this.poprModalComponent.close();
  }

  private createPoprModalComponentRef(): ComponentRef<PoprModalComponent<T>> {
    const factory = this.resolver.resolveComponentFactory<PoprModalComponent<T>>(PoprModalComponent);
    return factory.create(this.injector);
  }
}
